// @flow
import type {ExperimentVariant} from './types';

export const ON: ExperimentVariant = 'on';
export const OFF: ExperimentVariant = 'off';
